<template>
  <d2-container>
    <template slot="header">
      <el-input
          clearable
          style="width: 200px;margin-right: 20px;"
          class="filter-item"
          placeholder="输入用户 id"
          size="small"
          v-model="listQuery.accountId"
      ></el-input>
      <el-select
          v-model="listQuery.status"
          clearable
          placeholder="请选择状态"
          size="small"
          style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button @click="getSearch()" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="logList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
<!--    用户  -->
      <el-table-column align="center" label="用户">
        <template slot-scope="scope">
          <popover-user-info :id="scope.row.accountId"></popover-user-info>
        </template>
      </el-table-column>
      <el-table-column align="center" label="提现金额">
        <template slot-scope="scope">
          <span>¥{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payType === 0" type="warning">微信红包</el-tag>
          <el-tag v-if="scope.row.payType === 1" type="success">银行卡</el-tag>
          <el-tag v-if="scope.row.payType === 2" >微信账户</el-tag>
          <el-tag v-if="scope.row.payType === 3" >支付宝</el-tag>
          <el-tag v-if="scope.row.payType === 4" >企业付款</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="实际到账" align="center">
        <template slot-scope="scope">
          <span>¥{{ scope.row.actualAmount }}</span>
        </template>
      </el-table-column>

      <el-table-column label="手续费" align="center">
        <template slot-scope="scope">
          <span>¥{{ scope.row.serviceCharge }}</span>
        </template>
      </el-table-column>
      <el-table-column label="税费" align="center">
        <template slot-scope="scope">
          <span>¥{{ scope.row.taxes }}</span>
        </template>
      </el-table-column>

      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="warning">待审</el-tag>
          <el-tag v-if="scope.row.status === 1" type="success">待到账</el-tag>
          <el-tag v-if="scope.row.status === 2" >已拒绝</el-tag>
          <el-tag v-if="scope.row.status === 3" >已到账</el-tag>
          <el-tag v-if="scope.row.status === 4" >转账出错</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="审核备注">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="提交时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="审核时间">
        <template slot-scope="scope">
          <span>{{ scope.row.auditTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="success"
            v-if="scope.row.status === 0"
            @click="audit(scope.row.id, scope.row.accountId,1, scope.row.payType)"
            style="margin-top: 10px;"
          >✅通过</el-button>
          <el-button
            size="small"
            type="danger"
            v-if="scope.row.status === 0"
            @click="audit(scope.row.id, scope.row.accountId,2, scope.row.payType)"
            style="margin-top: 10px;"
          >🫸拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>

import { getAccountInfo, getUserTagList, removeUserTag } from '@/api/demo/user'
import { getWithdrawAudit, getWithdrawLog } from '@/api/demo/wallet'
import PopoverUserInfo from '@/components/users/popoverUserInfo.vue'

export default {
  name: 'userTag',
  components: { PopoverUserInfo },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      logList: [],
      form: {
        color: '', // 名称
        word: '' // 关键词
      },
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        status: 0,
        accountId: null
      },
      statusList: [
        { id: 0, name: '待审' },
        { id: 1, name: '通过' },
        { id: 2, name: '拒绝' },
        { id: 3, name: '到账' },
        { id: 4, name: '出错' }
      ],
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
    }
  },
  methods: {
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getWithdrawLog(this.listQuery).then(
        res => {
          that.listLoading = true
          that.logList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    audit (id, accountId, status, payType) {
      let that = this
      // 确认并输入备注
      let tip = '通过审核后，系统将自动转账到指定账户'
      if (payType === 4) {
        tip = '注意：当前提现提现申请为「企业打款」需要进行手动操作，请确保已经进行了企业付款操作'
      }
      this.$prompt(`${tip}  `, `确认「${status === 1 ? '通过' : '拒绝'}」审核`, {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入备注',
        inputPattern: /\S/,
        inputErrorMessage: '备注不能为空'
      }).then(({ value }) => {
        getAccountInfo(accountId).then(res => {
          getWithdrawAudit(id, status, value, res.mpOpenId).then(
            res => {
              that.$message({
                type: 'success',
                message: '操作成功!'
              })
              that.getSearch()
            },
            err => {
              console.log('res', err)
            })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
